import React, { createContext, ReactElement } from 'react';
import { useLogging } from '../hooks';
import LoggingContextType from './LoggingContextType';

const LoggingContext = createContext<LoggingContextType>({
  logInfo: () => {
    return;
  },
  logWarn: () => {
    return;
  },
  logError: () => {
    return;
  },
  flush: () => {
    return;
  }
});

interface LoggingProviderProps {
  children: ReactElement;
}

export const LoggingProvider = (props: LoggingProviderProps) => {
  const logMethods = useLogging();
  return <LoggingContext.Provider value={logMethods}>{props.children}</LoggingContext.Provider>;
};

export default LoggingContext;
